import { render } from "./CustomForm.vue?vue&type=template&id=8776a2e0"
import script from "./CustomForm.vue?vue&type=script&lang=js"
export * from "./CustomForm.vue?vue&type=script&lang=js"

import "./CustomForm.vue?vue&type=style&index=0&id=8776a2e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__